/* @flow */
import Config from 'Config';
import Entity from 'lib/Entity';

import QueryString from 'qs';
import xhr from 'xhr';

const URL = Config.Environment.R101_ZENDESK_URL;

export default class Faq extends Entity {
  getUrl() {
    return this.get('html_url');
  }

  getTitle() {
    return this.get('title');
  }

  getBody() {
    return this.get('body');
  }

  static searchFaqs(query, locale = 'en-US') {
    return new Promise((resolve, reject) => {
      xhr({
        url: `${URL}/api/v2/help_center/articles/search?` + QueryString.stringify({
          query,
          locale,
        }),
        method: 'GET',
      }, function(err, response, body) {
        if (err || response.statusCode >= 400) {
          // TODO: Wrap the error response into something easier to use.
          reject(err || body);
        } else {
          resolve(JSON.parse(body).results);
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/entities/Faq.js